import TeamIcon from '@/components/Svg/school/menu/team'

export const routeFrontOfficeManageUserTeam = [
  {
    route: 'TeamsList',
    text: 'Mon équipe',
    t: 'routes.frontoffice.all.teamsList',
    icon: TeamIcon,
    href: '/frontoffice/group/user-team/user-team-list',
    menuHeader: true,
    position: 200,
    isMobile: false,
  },
  {
    route: 'editUser',
    text: "Editer un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserEdit',
    href: '/frontoffice/group/user-team/edit-user-team/[userId]',
  },
  {
    route: 'TeamUserAdd',
    text: "Ajouter un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserAdd',
    href: '/frontoffice/group/user-team/add-user-team',
  },
]
